// E-Learning (Learner Portal) Routes - Supplier UI
export default [
  {
    path: '/elearning/students/browse-courses',
    name: 'supplier-browse-courses',
    meta: {
      authRequired: true,
      title: 'Browse Courses',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', active: true },
        { text: 'Browse Courses', active: true },
      ],
    },
    component: () => import('@/views/elearning/students/browse-courses.vue'),
  },
  {
    path: '/elearning/students/my-courses',
    name: 'supplier-my-courses',
    meta: {
      authRequired: true,
      title: 'My Courses',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', active: true },
        { text: 'My Courses', active: true },
      ],
    },
    component: () => import('@/views/elearning/students/my-courses.vue'),
  },
  {
    path: '/elearning/students/course/:id',
    name: 'supplier-course-student-view',
    meta: {
      authRequired: true,
      title: 'Course',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', to: '/elearning/students/my-courses' },
        { text: 'Course', active: true },
      ],
    },
    component: () => import('@/views/elearning/course-student-view.vue'),
  },
  {
    path: '/elearning/lessons/view/:id',
    name: 'supplier-view-lesson',
    meta: {
      authRequired: true,
      title: 'View Lesson',
    },
    component: () => import('@/views/elearning/view-lesson.vue'),
  },
  {
    path: '/elearning/view-assessment',
    name: 'supplier-view-assessment',
    meta: {
      authRequired: true,
      title: 'Assessment',
      breadcrumb: [
        { text: 'Dashboard', to: '/dashboard' },
        { text: 'E-Learning', to: '/elearning/students/my-courses' },
        { text: 'Assessment', active: true },
      ],
    },
    component: () => import('@/views/elearning/view-assessment.vue'),
  },
];
